import React from "react";
import { IoIosCloseCircle } from "react-icons/io";
import ReactModal from "react-modal";
import { useNavigate } from "react-router-dom";


const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: '450px',
    height: '200px',
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "Pink",
    padding: "3em",
  },
  // content: {
  //     top: "50%",
  //   left: "50%",
  //   right: "auto",
  //   bottom: "auto",
  //   width: '400px',
  //   height: '300px',
  //   // marginRight: "-50%",
  //   transform: "translate(-50%, -50%)",
  //   padding: '3em',
  //   borderRadius: '8px',
  //   backgroundColor: "Pink",
  //   inset: 'unset' // removes default positioning
  // },

  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  }

};

const ViewSubDomainAlert = ({ modalOpen, closeModal, alertData="" }) => {
    const navigate = useNavigate();
console.log("alertData",alertData)
  return (
    <div >
      <ReactModal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Password Modal"
        ariaHideApp={false} ///  shows error if ariaHideApp is not define as false
      >
       
       
         
         <h4 className='text-black text-center'> </h4>
         <p>{alertData}</p>
 
        
         <div className="mt-10 btn-wrapper">
         
          
          
        
       

        </div>
        <div className="mt-20  text-center"> <button
            className="btn-sm  btn-red rounded-5"
            onClick={() => closeModal(false)}
          >
            Close
          </button></div>
       
      </ReactModal>
    </div>
  );
};

export default ViewSubDomainAlert;
